import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Field, Formik } from "formik";
import { TextField } from "formik-mui";
import Mark from "../assets/svg/mark.svg";
import Google from "../assets/svg/google.svg";
import Facebook from "../assets/svg/facebook.svg";
import Apple from "../assets/svg/apple.svg";
import Logo from "../components/icons/Logo";
import CoverImage from "../components/icons/CoverImage";
import { useAuth } from "../context/AuthContext";
import Spinner from "../components/Loader/Spinner";
import { initialSigninValues, signinSchema } from "../schemas/AuthSchema";

const Login = () => {
  const { login, loading } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };
  const submitHandler = async (values) => {
    await login(values);
  };

  return (
    <div className="flex w-full min-h-screen overflow-hidden md:h-screen">
      <CoverImage />
      <div className="flex items-center justify-between py-12 flex-col w-full md:w-[50%]">
        <div className="hidden md:block">
          <Logo />{" "}
        </div>
        <div className="w-full h-full flex flex-col items-center justify-center overflow-scroll scrollbar-hide">
          <div className="md:hidden mb-12">
            <Logo />{" "}
          </div>
          <Formik onSubmit={submitHandler} initialValues={initialSigninValues} validationSchema={signinSchema}>
            {({ handleSubmit, values }) => (
              <div className="w-full flex flex-col items-center justify-center ">
                <div className="pt-8">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"email"}
                      value={values.email || ""}
                      label="Email"
                      component={TextField}
                      className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                    />
                    <img src={Mark} alt="mark" className={`text-gray-500 top-[26px] -translate-y-1/2 right-4 absolute`} />
                  </div>
                </div>
                <div className="pt-8">
                  <div className="mt-1 relative flex md:justify-end">
                    <Field
                      name={"password"}
                      value={values.password || ""}
                      onKeyDown={(e) => {
                        e.key === "Enter" && handleSubmit();
                      }}
                      label="Password"
                      component={TextField}
                      type={`${showPassword ? "text" : "password"}`}
                      className="border w-full md:w-[337px] border-primary  rounded px-2  focus:outline-none text-[14px] font-semibold "
                    />
                    <i
                      onClick={togglePassword}
                      className={`text-gray-500 top-[26px]  -translate-y-1/2 right-4 absolute fa-solid fa-eye${showPassword ? "" : "-slash"}`}
                    ></i>
                  </div>
                </div>
                <div className="mt-1 relative flex md:justify-end">
                  <div className="pt-5 text-[9px] flex justify-end font-semibold text-[red] w-[210px] md:w-[337px]">
                    <p>Forgot password? </p>
                  </div>
                </div>

                <p className="text-[12px] md:text-base font-semibold text-[#ACACAC] mt-[40px]">
                  Don't have an account?
                  <Link to="/register">
                    {" "}
                    <span className="text-primary cursor-pointer pl-2">Sign up</span>
                  </Link>
                </p>
                <button
                  onClick={handleSubmit}
                  className="w-[200px] md:w-[337px] h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold"
                >
                  {loading ? <Spinner /> : "Login"}{" "}
                </button>
              </div>
            )}
          </Formik>
          <div className="flex gap-4 w-[150px] md:w-[300px] items-center mt-[20px]">
            <div className="h-[1px] bg-[#707070] w-full"></div>
            <p>or</p>
            <div className="h-[1px] bg-[#707070] w-full"></div>
          </div>
          <div className="flex  gap-2 md:gap-6 mt-[20px]">
            <img src={Google} alt="google_logo" />
            <img src={Facebook} alt="facebook_logo" />
            <img src={Apple} alt="apple_logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
